var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-checkbox',{model:{value:(_vm.autoscaleYAxis),callback:function ($$v) {_vm.autoscaleYAxis=$$v},expression:"autoscaleYAxis"}},[_vm._v("\n  Autoscale y-axis\n")])}
var staticRenderFns = []

export { render, staticRenderFns }